import React from 'react';
import { SignupForm } from '../../components/signup/SignupForm';
import { Box } from '@mui/joy';

export const SignupPage: React.FC = () => {
  return (
    <Box 
      sx={{ 
        minHeight: '100vh', 
        backgroundColor: 'background.level1',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        p: 2
      }}
    >
      <SignupForm />
    </Box>
  );
};